var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76001 7.21957V16.7896C3.76001 18.7496 5.89001 19.9796 7.59001 18.9996L11.74 16.6096L15.89 14.2096C17.59 13.2296 17.59 10.7796 15.89 9.79957L11.74 7.39957L7.59001 5.00957C5.89001 4.02957 3.76001 5.24957 3.76001 7.21957Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.24 18.9303C19.83 18.9303 19.49 18.5903 19.49 18.1803V5.82031C19.49 5.41031 19.83 5.07031 20.24 5.07031C20.65 5.07031 20.99 5.41031 20.99 5.82031V18.1803C20.99 18.5903 20.66 18.9303 20.24 18.9303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.075398527dfa85837eb30f3627bcbc96.svg";
export { ForwardRef as ReactComponent };